module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Light-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Light-webfont.svg
// module id = 348
// module chunks = 0